// extracted by mini-css-extract-plugin
export default {"page":"Login_page__jYOt-","title":"Login_title__g9t3r","button":"Login_button__y-lzl","buttonTitle":"Login_buttonTitle__4QGvf"};